import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useIntl } from 'react-intl';

import { getResponseMessage } from '../../../../utils/utils';
import { postCancelBalanceRequest } from '../../../../crud/balanceRequest.crud';
import { IPostCompleteData } from '../../../../interfaces/balanceRequest';

type UseDeclineReturn = [
  (paymentId: string,  data: IPostCompleteData) => Promise<void>,
  boolean,
  boolean
];

export const useDecline = (): UseDeclineReturn => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  
  const fetchDecline = useCallback(async (paymentId: string, data: IPostCompleteData) => {
    setLoading(true);
    setSuccess(false);

    try {
      await postCancelBalanceRequest(paymentId, data);

      enqueueSnackbar('Successfully declined', {
        variant: 'success',
      });

      setSuccess(true);
    } catch (e) {
      enqueueSnackbar(
        `${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`,
        { variant: 'error' }
      );
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar, intl]);

  return [fetchDecline, loading, success];
};
